<template>
  <div class="editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <i class="fa fa-bold"></i>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <i class="fa fa-italic"></i>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <i class="fa fa-underline"></i>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <i class="fa fa-list"></i>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <i class="fa fa-list-ol"></i>
        </button>
      </div>
    </editor-menu-bar>
    <editor-content class="editor__content" :editor="editor" v-model="editor.content"/>
  </div>
</template>

<script>

import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Link,
  Underline,
} from 'tiptap-extensions'

export default {
    name: 'WYSIWYG',
    components: {
        EditorContent,
        EditorMenuBar,
    },
    props: {
        content: String,
    },
    methods: {
        updateContent: function(data){
            let new_content = data.getHTML()
            this.$emit('input', new_content);
        }
    },
    data() {
        return {
            editor: new Editor({
                extensions: [
                    new BulletList(),
                    new HardBreak(),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link(),
                    new Bold(),
                    new Italic(),
                    new Underline(),
                ],
                content: this.content,
                onUpdate: this.updateContent,
            })
        }
    },
    beforeDestroy() {
        this.editor.destroy()
    },
    mounted() {},
}
</script>

<style scoped>
    .editor >>> .ProseMirror{
        border: 0px;
        box-shadow: none;
        outline: 0 none;
        min-height: 60px;
    }
    .editor__content{
        border-top: 1px solid #ccc;
        padding: 10px;
    }
    .editor{
        border: 1px solid #ccc;
    }
    .menubar{
        background: #f8f8f8;
    }
    .menubar__button{
        background: none;
        border: 0px;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 4px 7px;
    }
</style>
